import { SALE_CAMPAIGNS, isAnActiveCampaign } from 'utils/checkCampaign'
import systemsConstants from './systemsConstants'

const highPriorityTags = [
  'Corujão',
  'Novidade',
  process.env.REACT_APP_CAMPAIGN,
  process.env.REACT_APP_SECOND_CAMPAIGN,
]

const parseConcurenceTag = tags => {
  const newTags = [...tags]
  const concurrencePosition = newTags.indexOf('Concorrência pública')

  if (concurrencePosition !== -1) {
    newTags.splice(concurrencePosition, 1)
    newTags.splice(0, 0, systemsConstants.CONCORRENCIA)
  }
  return newTags
}

const reorderTagArray = (tagsToReorder, tags) => {
  let reorderedTags = [...tags]

  tagsToReorder.forEach(newTag => {
    const indexToRemove = reorderedTags.indexOf(newTag)
    reorderedTags = reorderedTags.splice(newTag, indexToRemove)
    reorderedTags.unshift(newTag)
  })

  return reorderedTags
}

const extractHighPriorityTags = tags => {
  const tagsToReorder = tags
    .filter(tag => highPriorityTags.includes(tag))
    .reverse()

  return tagsToReorder
}

const orderTags = tags => {
  if (tags.some(tag => highPriorityTags.includes(tag))) {
    const tagsToReorder = extractHighPriorityTags(tags)
    const reorderedTags = reorderTagArray(tagsToReorder, tags)
    return reorderedTags
  }

  return tags
}

const parseTags = tags => {
  const newTags = [...tags]

  const corujaoPosition = newTags.findIndex(value => /Coruj[aã]o/i.test(value))
  const cashbackPosition = newTags.findIndex(value => /Cashback/i.test(value))

  if (
    SALE_CAMPAIGNS.cashback.test(newTags[cashbackPosition]) &&
    isAnActiveCampaign(SALE_CAMPAIGNS.blackout)
  ) {
    newTags.splice(cashbackPosition, 1, 'Blackout')
  }

  if (
    SALE_CAMPAIGNS.corujao.test(newTags[corujaoPosition]) &&
    isAnActiveCampaign(SALE_CAMPAIGNS.blackoutDay)
  ) {
    newTags.splice(corujaoPosition, 1, 'BlackoutDay')
  }

  return newTags
}

const handleTags = dataTag => {
  let newTags = dataTag.map(tag => tag)
  newTags = newTags.filter(tag => tag && tag)

  newTags = parseConcurenceTag(newTags)

  newTags = parseTags(newTags)

  newTags = orderTags(newTags)

  return newTags
}

export default handleTags
